import CloseIcon from '@mui/icons-material/Close'
import { Drawer, IconButton } from '@mui/material'

import useGetElementDimensions from '~/features/ui/hooks/useGetElementDimensions'
import EElement from '~/features/ui/models'
import { scenariosSideNavWidthInPixels } from '~/layouts/account/scenariosLayout/constants'
import DrawerContent from '~/layouts/account/scenariosLayout/scenariosSideNav/drawerContent'
import rem from '~/utils/ui'

function ScenariosSideNav({
  mobileOpen,
  setMobileOpen,
}: {
  mobileOpen: boolean
  setMobileOpen: (open: boolean) => void
}) {
  const { height: headerHeight } = useGetElementDimensions(
    EElement.accountHeader,
  )
  const handleClose = () => setMobileOpen(false)

  return (
    <>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true,
        }}
        sx={(theme) => ({
          display: { xxxs: 'block', md: 'none' },
          zIndex: theme.zIndex.drawer - 1,
          '& .MuiDrawer-paper': {
            zIndex: theme.zIndex.drawer - 1,
            top: rem(headerHeight),
            height: `calc(100% - ${rem(headerHeight)})`,
            boxSizing: 'border-box',
            width: '100%',
            pt: rem(36),
            px: rem(24),
            pb: rem(24),
          },
        })}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="large"
          sx={{
            position: 'absolute',
            top: rem(6),
            right: rem(6),
          }}
        >
          <CloseIcon />
        </IconButton>
        <DrawerContent onClose={handleClose} />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xxxs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            position: 'static',
            height: '100%',
            boxSizing: 'border-box',
            width: rem(scenariosSideNavWidthInPixels),
            p: rem(24),
          },
        }}
        open
      >
        <DrawerContent onClose={handleClose} />
      </Drawer>
    </>
  )
}

export default ScenariosSideNav
